import React from "react";
import { useQuery } from "@tanstack/react-query";
import { BadgeCheck } from "lucide-react";
import { getTestimonials } from "@/lib/api";
import { Container } from "@/components/Container";
import { SectionHeading } from "@/components/SectionHeading";

export default function VerifiedTestimonials() {
  const { data } = useQuery({
    queryKey: ["verified-testimonials"],
    queryFn: getTestimonials,
    staleTime: 5 * 60 * 1000,
  });
  const items = data || [];
  if (!items.length) return null;

  return (
    <section className="bg-[var(--ibp-offwhite)] py-16 sm:py-20">
      <Container>
        <SectionHeading
          kicker="Student feedback"
          title="Shared by real Illinois Broker Prep customers."
          subtitle="Published only with the customer's permission. Names stay private unless the customer chooses otherwise."
        />
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {items.slice(0, 3).map((item, index) => (
            <blockquote
              key={`${item.attribution}-${index}`}
              className="rounded-2xl border border-[color:rgba(10,27,51,0.12)] bg-white p-6 shadow-[0_10px_30px_rgba(7,20,39,0.05)]"
            >
              <BadgeCheck className="h-5 w-5 text-[#15803d]" />
              <p className="mt-4 text-sm leading-7 text-[var(--ibp-ink)]">&ldquo;{item.quote}&rdquo;</p>
              <footer className="mt-4 text-xs font-semibold text-[color:rgba(11,18,32,0.58)]">
                {item.attribution}
                {item.passed_exam ? " - Reported passing the exam" : ""}
              </footer>
            </blockquote>
          ))}
        </div>
      </Container>
    </section>
  );
}
